export enum Locale {
  English = 'en',
  German = 'de',
  Hungarian = 'hu',
  Romanian = 'ro'
}
